// @ts-nocheck
import LocalDB from './localdb.ts';
import scan from './scan.ts';
import loadEditor from './editor.ts';
import dedupe from './util/dedupe.ts';
import sendMessage from './message.ts';
import log from './util/log.ts';
import getDomPath from './dompath.ts';

// Initialize configuration settings for the application
let nonTranslatedText = [];
let translatedText = [];
let isTranslating = false;
let lastTranslation = null;

const originUrl = new URL(document.currentScript.src)
const targetOrigin = `${originUrl.protocol}//${originUrl.host}`
const defaultLang = 'en';
const cacheEnabled = (window.top === window.self);


if(!cacheEnabled) log('Cache disabled.');

// Parsing the query parameters from the current script source to get the 'key'
const params = new URLSearchParams(document.currentScript.src.split('?')[1]);
const key = params.get('orgId');
const urlLang = new URLSearchParams(window.location.search.split('?')[1]).get('lang')
const host = (new URL(document.currentScript.src)).host


// Asynchronous function to handle translation
async function translate() {
    if (isAlreadyTranslating()) return;

    const targetLang = getTargetLanguage();

    // Handle cross-frame communication
    if (window.top !== window.self) {
        sendMessage({ type: 'setLang', lang: targetLang });

        sendMessage({
            type: 'loading'
        });
    }

    // Exit if the target language is the default language
    if (targetLang === defaultLang) {
        return endTranslation([], true);
    }

    let cache = null;
    let db = null;

    // Initialize and retrieve from cache if enabled
    if (cacheEnabled) {
        try {
            db = await initializeDatabase();
            cache = await db.get(targetLang);
        } catch (error) {
            log('Error initializing database or retrieving cache: ' + error);
        }
    }

    let { nonTranslatedText, translatedText } = scanDocument(cache);

    log(`${nonTranslatedText.length} nontranslated items.`);
    log(`${translatedText.length} translated items.`);

    // Exit if cache hit
    if (isCacheHit(nonTranslatedText)) {
        return endTranslation(translatedText, true);
    }

    // Fetch translations for non-translated text
    try {
        let fetchedData = await fetchTranslations(nonTranslatedText, targetLang);

        if (cacheEnabled) {
            await updateCache(db, targetLang, cache, fetchedData);
            cache = await db.get(targetLang);
            console.log('cache', cache)
        }

        translatedText = scanDocument(cacheEnabled ? cache : { translations: fetchedData }).translatedText;

        log(`${translatedText.length} translated items.`);
    } catch (error) {
        log('Error fetching translations or updating cache: ' + error);
    }

    return endTranslation(translatedText, true);
}

function isAlreadyTranslating() {
    if (isTranslating) {
        return true;
    }
    isTranslating = true;
    return false;
}

function getTargetLanguage() {
    if (urlLang) {
        return urlLang;
    }
    return document.documentElement.lang || 'en';
}

async function initializeDatabase() {
    let db = new LocalDB('verbos');
    await db.open('translations');
    return db;
}

function scanDocument(cache) {
    return scan(cache, nonTranslatedText, translatedText);
}

function isCacheHit(textArray) {
    if (textArray.length === 0) {
        log('100% cache hit.');
        return true;
    }
    return false;
}

async function fetchTranslations(nonTranslatedText, targetLang) {
    const response = await fetch(`${targetOrigin}/api/translate`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'x-verbos-org-id': key
        },
        body: JSON.stringify({
            text: nonTranslatedText.map(item => item.original),
            source_lang: 'en',
            target_lang: targetLang
        })
    });
    log(`Fetched ${nonTranslatedText.length} translations from API.`);
    return response.json();
}

async function refreshCache() {
    const targetLang = getTargetLanguage();
    let db = await initializeDatabase();
    let cache = await db.get(targetLang);

    if (!cache) return;

    log(`Refreshing cache for ${targetLang}`)

    // get _id and updatedAt field from cache to array
    let cacheIds = cache.translations.map(item => {
        return { _id: item._id, updatedAt: item.updatedAt }
    })

    const refreshItems = await fetch(`${targetOrigin}/api/translate/cache`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'x-verbos-org-id': key
        },
        body: JSON.stringify(cacheIds)
    });

    const refreshItemsJson = await refreshItems.json();

    if (refreshItemsJson.length === 0) return;

    // replace items in cache.translations
    for (let i = 0; i < refreshItemsJson.length; i++) {
        const item = refreshItemsJson[i];
        const index = cache.translations.findIndex(cacheItem => cacheItem._id === item._id);
        cache.translations[index] = item;
        console.log(index)
    }

    await db.put({ id: targetLang, translations: cache.translations });

    return true;

}

async function updateCache(db, lang, cache, newData) {
    if(!cacheEnabled) return;
    cache = cache ? [...cache.translations, ...newData] : newData;
    await db.put({ id: lang, translations: cache });
}

async function endTranslation(translatedText, success = false) {
    if (window.top !== window.self) {
        log(`Sending ${translatedText.length} items to editor.`)
        sendMessage({
            type: 'translationitems',
            items: translatedText
        });
    }
    if(cacheEnabled){ await refreshCache()}
    isTranslating = false;
    lastTranslation = new Date().getTime();
    return success;
}

// Invoke the translate function
translate();

// Modify history.pushState to handle URL changes in single-page applications
let pushState = history.pushState;
history.pushState = function () {
    nonTranslatedText = [];
    translatedText = [];
    pushState.apply(history, arguments);
    setTimeout(translate, 0);
};

// Set up a MutationObserver to listen for changes in the DOM
const observer = new MutationObserver((mutationsList, observer) => {
    // Log mutations and re-invoke translation for new or changed DOM elements
    for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
            log('DOM mutation detected. Re-scanning DOM.')
            console.log(getDomPath(mutation.target));
            translate();
        }
    }
});

// Start observing the document body for DOM changes
observer.observe(document.body, {
    attributes: true,
    childList: true,
    subtree: true
});

// watch translation status for changes
if (window.top !== window.self) {

    log('Watching translation status for changes.');
    setInterval(pollValue, 100);

    if (urlLang) {
        document.addEventListener('click', function (event) {
            if (event.target.tagName === 'A') {
                const originalUrl = event.target.href;

                const urlObject = new URL(originalUrl);
                // Get existing search parameters
                const params = urlObject.searchParams;
                // Add or update the parameter
                params.set('lang', urlLang);

                event.preventDefault();
                window.location.href = urlObject.href;
            }
        });

    }

}

let lastKnownValue = lastTranslation; // Store the last known value for comparison

const getValueFromSomeWhere = () => {
    return lastTranslation;
}

// Polling function
function pollValue() {
    lastTranslation = getValueFromSomeWhere(); // Replace this with the logic to get the current value

    if (lastTranslation !== lastKnownValue) {
        loadEditor(sendMessage, targetOrigin, getTargetLanguage, observer);
        lastKnownValue = lastTranslation; // Update the last known value
    }
}
